import { MenuItem, SearchSuggestionItem } from "../Types/Layout/SidebarType";
import { IUserMenusList } from "../Types/UserProfileDetails";
import {
  Href,
  lanClass1,
  lanClass3,
  lanClass4,
  link,
  sub,
  user as userIcon,
} from "./Constant";

const normalizePath = (route?: string | null) => {
  const trimmedRoute = route?.trim();

  if (!trimmedRoute) return Href;
  if (
    trimmedRoute.startsWith("/") ||
    trimmedRoute.startsWith("http://") ||
    trimmedRoute.startsWith("https://")
  ) {
    return trimmedRoute;
  }

  return `/${trimmedRoute}`;
};

const sortMenus = (menus: IUserMenusList[]) =>
  [...menus].sort((firstMenu, secondMenu) => {
    const firstOrder = firstMenu.sort_order ?? firstMenu.order ?? firstMenu.id;
    const secondOrder =
      secondMenu.sort_order ?? secondMenu.order ?? secondMenu.id;

    return firstOrder - secondOrder;
  });

const buildMenuHierarchy = (menus: IUserMenusList[]) => {
  const hasFlatChildRelations = menus.some((menu) => Number(menu.parent_id) > 0);

  if (!hasFlatChildRelations) return menus;

  const menuMap = new Map<number, IUserMenusList>();

  menus.forEach((menu) => {
    menuMap.set(menu.id, {
      ...menu,
      children: [],
    });
  });

  const rootMenus: IUserMenusList[] = [];

  menuMap.forEach((menu) => {
    const parentId = Number(menu.parent_id);
    const parentMenu = parentId ? menuMap.get(parentId) : undefined;

    if (parentMenu && parentMenu.id !== menu.id) {
      parentMenu.children = [...(parentMenu.children ?? []), menu];
      return;
    }

    rootMenus.push(menu);
  });

  return rootMenus;
};

const mapApiMenuToSidebarItem = (
  menu: IUserMenusList,
  level = 0
): MenuItem => {
  const children = sortMenus(menu.children ?? [])
    .filter((child) => Number(child.status) === 1)
    .map((child) => mapApiMenuToSidebarItem(child, level + 1));
  const hasChildren = children.length > 0;
  const icon = menu.icon?.trim() || (level === 0 ? userIcon : undefined);

  return {
    id: menu.id,
    title: menu.name,
    icon,
    type: hasChildren ? sub : link,
    path: hasChildren ? undefined : normalizePath(menu.route),
    lanClass: level === 0 ? lanClass3 : lanClass4,
    ...(hasChildren ? { children } : {}),
  };
};

export const buildSidebarMenuFromApi = (
  userMenus: IUserMenusList[]
): MenuItem[] => [
  {
    lanClass: lanClass1,
    Items: sortMenus(buildMenuHierarchy(userMenus))
      .filter((menu) => Number(menu.status) === 1)
      .map((menu) => mapApiMenuToSidebarItem(menu)),
  },
];

export const collectSidebarLinkSuggestions = (
  sidebarMenus: MenuItem[]
): SearchSuggestionItem[] => {
  const suggestionArray: SearchSuggestionItem[] = [];
  let id = 0;

  const collect = (item: MenuItem, icon: string | undefined) => {
    if (item.children?.length) {
      item.children.forEach((child) => collect(child, icon || child.icon));
      return;
    }

    id += 1;
    suggestionArray.push({
      icon,
      title: item.title || "",
      path: item.path || "",
      bookmarked: false,
      id,
    });
  };

  sidebarMenus.forEach((section) => {
    section.Items?.forEach((item) => collect(item, item.icon));
  });

  return suggestionArray;
};
